// extracted by mini-css-extract-plugin
export default {"parent-mode":"card_parent-mode__SsI+L","card":"card_card__7WVYK","clickable":"card_clickable__eb6ei","blocked":"card_blocked__9X7SN","offlineOverlay":"card_offlineOverlay__U6+sA"};